import { Variants } from "framer-motion";

export const growRouteVariants: Variants = {
  initial: { opacity: "0%", scale: 0.98 },
  final: { opacity: "100%", scale: 1 },
};

export const growRouteProps = {
  variants: growRouteVariants,
  initial: "initial",
  animate: "final",
  exit: "initial",
} as const;

export const fadeRouteVariants: Variants = {
  initial: { opacity: "0%" },
  final: { opacity: "100%" },
};

export const fadeRouteProps = {
  variants: fadeRouteVariants,
  initial: "initial",
  animate: "final",
  exit: "initial",
} as const;
